module.exports = "pegasus_template/assets/tech/small/2.jpg";